import { RIDER_WALLET_VOCABULARIES } from './rider-wallet.js';
/** Slice d737 of the catalog: the rider's signed "Saldo Vello" (D737, ADR-0150) - its movements, adjustments and the refusals of the Admin routes. */
export const SLICE_D737 = [...RIDER_WALLET_VOCABULARIES];
//# sourceMappingURL=slice-d737.js.map